function normalizeEnvValue(value) {
  if (!value) return '';
  const trimmed = value.trim();
  if (
    (trimmed.startsWith('"') && trimmed.endsWith('"'))
    || (trimmed.startsWith("'") && trimmed.endsWith("'"))
  ) {
    return trimmed.slice(1, -1);
  }
  return trimmed;
}

function env(key, fallback = '') {
  return normalizeEnvValue(process.env[key]) || fallback;
}

export const PORTAL_BACKEND_URL = env('REACT_APP_PORTAL_BACKEND_URL', 'https://app.greenstitch.io');
export const PORTAL_AUTH_EMAIL = env('REACT_APP_PORTAL_AUTH_EMAIL', 'atlas-admin@greenstitch.io');
export const PORTAL_AUTH_PASSWORD = env('REACT_APP_PORTAL_AUTH_PASSWORD', '123');
export const ESG_STORAGE_ACCOUNT_NAME = env('REACT_APP_ESG_STORAGE_ACCOUNT_NAME', 'greenstitchesgdocuments');
export const ESG_STORAGE_CONTAINER = env('REACT_APP_ESG_STORAGE_CONTAINER') || 'esg-documents';
export const FILE_STORAGE_HOST = env('REACT_APP_FILE_STORAGE_HOST', 'greenstitch-account.s3.eu-central-1.amazonaws.com');
